import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageLoader } from '@app/components/PageLoader';
import { Table } from '@app/components/Table';
import { useIsMobile } from '@app/utils/isMobile';
import { mapScheduleItemsToTableData } from '@modules/borrower/utils/mapScheduleItemsToTableData';
import { sortSheduleItems } from '@modules/borrower/utils/sortSheduleItems';
import PaymentsScheduleMobile from './mobile/PaymentsScheduleMobile';
import { getPaymentsScheduleColums } from './utils/getPaymentsScheduleColums';
const PAGE_SIZE = 10;
const PaymentsSchedule = ({ scheduleItems, loading = false }) => {
    const { t } = useTranslation();
    const [isMobile] = useIsMobile();
    const [allItems, setAllItems] = useState([]);
    const [sortBy, setSortBy] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
        setAllItems(scheduleItems);
    }, []);
    const handleSortChange = useCallback((newSortBy) => {
        setSortBy(newSortBy);
        setCurrentPage(1);
    }, []);
    const columns = getPaymentsScheduleColums(t);
    const processedData = useMemo(() => {
        const sortedItems = [...allItems];
        if (sortBy.length > 0) {
            const { id, desc } = sortBy[0];
            sortedItems.sort(sortSheduleItems(id, desc));
        }
        return mapScheduleItemsToTableData(sortedItems);
    }, [sortBy, allItems.length]);
    const handlePageChange = useCallback((page) => {
        setCurrentPage(page);
    }, []);
    if (loading) {
        return <PageLoader />;
    }
    const totalItems = allItems.length;
    const totalPages = Math.ceil(totalItems / PAGE_SIZE);
    const paginatedItems = totalItems > PAGE_SIZE
        ? processedData.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE)
        : processedData;
    const paginationConfig = totalItems > PAGE_SIZE
        ? {
            onPageChange: handlePageChange,
            pageIndex: currentPage,
            pageSize: PAGE_SIZE,
            pageCount: totalPages,
            total: totalItems,
            locale: {
                details: {
                    showing: t('financing.pagination.showing'),
                    of: t('financing.pagination.of'),
                    items: '',
                },
            },
        }
        : undefined;
    return isMobile ? (<PaymentsScheduleMobile scheduleItems={processedData}/>) : (<Table columns={columns} data={paginatedItems} pagination={paginationConfig} containerClassName="overflow-x-auto" sorting={{
            sortBy,
            onSortChange: handleSortChange,
        }}/>);
};
export default PaymentsSchedule;
